import React from 'react'
import styled from 'styled-components'
import { Variables } from '../styles/Variables'
import Container from './Container'
import Heading, { HeadingColumnInner, StyledHeading } from './Heading'
import { BodyCopy, H1, H2, H6 } from './Typography'
import media from 'css-in-js-media'
import { X2HeadingSection } from './X2HeadingSection'
import { Col } from 'react-styled-flexboxgrid'
import { ImageWrap } from './ResponsiveImage'
import { StyledButton } from './ButtonStyled'

const Wrapper = styled.div`
    background-color: ${Variables.color.pazolaKarry};
    
    ${H1} {
        padding-top: 87px;
        text-align: center ;
        
        ${media('<desktop')} {
            padding-top: 40px;
        }
    }
`;

const HeadingWrap = styled.div`
    ${StyledHeading} {
        background-color: transparent;

        h3 {
            font-family: ${Variables.font.title};
            font-style: normal;
            font-weight: 300;
            font-size: 32px;
            line-height: 37px;
            color: ${Variables.color.pazola} ;   
            padding-bottom: 60px;
            text-transform: inherit;
            letter-spacing: initial;
            ${media('<desktop')} {
                font-size: 24px;
                line-height: 30px;
            }
        }

        h4 {
            font-family: ${Variables.font.title};
            font-style: normal;
            font-weight: 300;
            font-size: 24px;
            line-height: 30px;
            ${media('<desktop')} {
                font-size: 24px;
                line-height: 30px;
                text-align: left;
            }
        }

        ${BodyCopy} {
            font-family: ${Variables.font.body};
            font-style: normal;
            font-weight: 500;
            font-size: 18px;
            line-height: 22px;
            ${media('<desktop')} {
                text-align: center ;
                font-size: 16px;
                line-height: 20px;
            }
        }

        ${StyledButton} {
            background-color: transparent;
            border-color: ${Variables.color.pazola};
            width: 340px;
            &:hover {
                background-color: ${Variables.color.pazolaGold};
                color: ${Variables.color.white};
                border-color: ${Variables.color.pazolaGold};
                &::before {
                    border-color: ${Variables.color.white};
                }
            }
            &::before {
                border-color: ${Variables.color.pazola};
            }

            ${media('<desktop')} {
                width: 266px;
            }
        }
    }
    ${H2} {
        max-width: none;
        ${media('<desktop')} {
            white-space: normal;
        }
    }

    ${H6} {        
        font-family: ${Variables.font.body};
        font-weight: 500;
        font-size: 16px;
        line-height: 120%;
        letter-spacing: 0.0015em;
    }

    ${HeadingColumnInner} {
        margin-left: 0;
    }

    ${ImageWrap} {
        margin-left: 0;
    }
`

export const X2Heading: React.FC<{
    data: object
}> = ({ data }) => {
    return (
        <Wrapper>
            <H1>Owner Packages</H1>
            {data && data.headings && (
                <X2HeadingSection>                    
                    <Container>                        
                        {data.headings.map((d, i) => {
                            return (
                                <Col md={6} key={i}>
                                    <HeadingWrap key={i}>
                                        <Heading data={d} noMargin />
                                    </HeadingWrap>
                                </Col>
                            )
                        })}                        
                    </Container>
                </X2HeadingSection>
            )}
        </Wrapper>
    )
}
